/**
 * KAN-724: message by referral waiting in the queue of a client card.
 *
 * GET  /api/v1/clients/{id}/referral/          - is a message queued, from which account, when
 * POST /api/v1/clients/{id}/referral/send-now/ - send on the next planner tick outside the window
 */
import apiClient from './client';

export interface ClientReferralStatus {
  pending: boolean;
  account_id: string;
  account_label: string;
  run_at: string | null;
  text_preview: string | null;
}

export interface ClientReferralSendNowResult {
  queued: boolean;
  account_id: string;
  account_label: string;
  run_at: string;
}

export const clientReferralKey = (clientId: string) =>
  ['clients', clientId, 'referral'] as const;

export const clientReferralApi = {
  getStatus: async (clientId: string): Promise<ClientReferralStatus> => {
    const response = await apiClient.get<ClientReferralStatus>(
      `/api/v1/clients/${clientId}/referral/`
    );
    return response.data;
  },

  sendNow: async (clientId: string): Promise<ClientReferralSendNowResult> => {
    const response = await apiClient.post<ClientReferralSendNowResult>(
      `/api/v1/clients/${clientId}/referral/send-now/`
    );
    return response.data;
  },
};
